module.exports = __webpack_public_path__ + "static/media/link.57302289.svg";